import { BaseHttpService } from './base-http.service';
import { URLS } from '../shared/url';
import { ResponseTypeEnum } from '../models/enums';
import * as i0 from "@angular/core";
import * as i1 from "./base-http.service";
var DepartmentService = /** @class */ (function () {
    function DepartmentService(http) {
        var _this = this;
        this.http = http;
        this.getDepartmentList = function () {
            return _this.http.Get(URLS.getDepartmentList);
        };
        this.getDepartment = function (departmentId) {
            return _this.http.Get(URLS.getDepartment + "/" + departmentId);
        };
        this.saveDepartment = function (department) {
            return _this.http.Post(URLS.saveDepartment, department, ResponseTypeEnum.Success);
        };
        this.deleteDepartment = function (departmentId) {
            return _this.http.Delete(URLS.deleteDepartment + "/" + departmentId, ResponseTypeEnum.Success);
        };
    }
    DepartmentService.ngInjectableDef = i0.defineInjectable({ factory: function DepartmentService_Factory() { return new DepartmentService(i0.inject(i1.BaseHttpService)); }, token: DepartmentService, providedIn: "root" });
    return DepartmentService;
}());
export { DepartmentService };
